function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "32",
  viewBox: "0 0 30 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M25.375 6.771V3.812A2.875 2.875 0 0022.5.937h-15a2.875 2.875 0 00-2.875 2.875v2.959c0 4.101 2.386 7.59 5.864 9.229-3.478 1.639-5.864 5.128-5.864 9.229v2.959c0 1.212.75 2.25 1.812 2.672l.027.011c.321.124.67.192 1.035.192h15a2.866 2.866 0 001.062-.203 2.876 2.876 0 001.812-2.672v-2.959c0-4.101-2.386-7.59-5.864-9.229 3.48-1.639 5.866-5.128 5.866-9.229zM8.424 29.062C10.11 26.318 12.581 24.5 15 24.5s4.89 1.818 6.576 4.562H8.424zm14.951-3.833v2.942C21.361 24.8 18.268 22.5 15 22.5s-6.361 2.3-8.375 5.671v-2.942C6.625 20.636 10.341 17 15 17s8.375 3.636 8.375 8.229zM15 15c-4.659 0-8.375-3.636-8.375-8.229V3.812c0-.483.392-.875.875-.875h15c.483 0 .875.392.875.875v2.959C23.375 11.364 19.659 15 15 15z"
})));